export const SESSION_LIFETIME_IN_MINUTES = window.Xavier.config.sessionLifetime
    ? Number(window.Xavier.config.sessionLifetime)
    : 30;
